import { ENVIRONMENT } from "../constants";
function getTitle(vm) {
  const {
    title
  } = vm.$options;
  if (title) {
    return typeof title === "function" ? title.call(vm) : title;
  }
}
export default portal => ({
  computed: {
    $environmentPrefix() {
      return ENVIRONMENT !== "production" ? `[${ENVIRONMENT}] ` : "";
    },
    $portalText() {
      return this.$t("global.doorr")[portal];
    }
  },
  methods: {
    $setTitle() {
      const title = getTitle(this);
      if (title) {
        document.title = `${this.$environmentPrefix.toUpperCase()}${title} - ${this.$portalText} `;
      }
    }
  },
  activated() {
    this.$setTitle();
  },
  mounted() {
    this.$setTitle();
  }
});